export const categories = [
  { slug: 'romance', name: '恋爱漫', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事' },
  { slug: 'fantasy', name: '奇幻漫', icon: 'ri-magic-line', description: '穿越异世界的奇幻冒险' },
  { slug: 'action', name: '热血漫', icon: 'ri-fire-line', description: '激情澎湃的战斗篇章' },
  { slug: 'drama', name: '剧情漫', icon: 'ri-movie-line', description: '扣人心弦的剧情佳作' },
  { slug: 'thriller', name: '悬疑漫', icon: 'ri-search-eye-line', description: '紧张刺激的悬疑故事' },
  { slug: 'comedy', name: '搞笑漫', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑日常' },
  { slug: 'school', name: '校园漫', icon: 'ri-building-line', description: '青春洋溢的校园生活' },
  { slug: 'historical', name: '古风漫', icon: 'ri-ancient-gate-line', description: '唯美雅致的古风画卷' },
];

export const comics = [
  {
    id: 1,
    slug: 'the-legendary-warrior',
    title: '传奇战士的回归',
    author: '金泰亨',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20warrior%20with%20flowing%20dark%20hair%20holding%20a%20glowing%20sword%2C%20dramatic%20lighting%20with%20warm%20golden%20tones%2C%20epic%20fantasy%20atmosphere%2C%20clean%20composition%20on%20simple%20dark%20gradient%20background%2C%20anime%20art%20style%20with%20sharp%20lines%20and%20vibrant%20colors%2C%20professional%20digital%20illustration%2C%20high%20quality%20rendering&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    description: '被誉为传奇战士的姜贤，在一次任务中意外身亡。当他再次睁开眼睛时，竟然回到了十年前！带着前世的记忆与战斗经验，他决定改变命运，成为最强的战士。',
    status: '连载中',
    rating: 9.6,
    views: 12580000,
    chapters: 86,
    updatedAt: '2026-07-06',
    tags: ['重生', '战斗', '逆袭'],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 2,
    slug: 'secretarys-secret',
    title: '秘书的秘密',
    author: '李敏镐',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20woman%20in%20a%20stylish%20office%20outfit%20with%20long%20dark%20hair%2C%20romantic%20mood%20with%20soft%20pink%20and%20warm%20lighting%2C%20clean%20background%20with%20subtle%20bokeh%20effect%2C%20shojo%20manga%20aesthetic%2C%20delicate%20facial%20features%2C%20professional%20digital%20art%2C%20high%20quality%20illustration&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    description: '平凡的女秘书林秀雅，暗恋着自己的上司已经三年。直到有一天，她意外发现原来上司也藏着一个不为人知的秘密...一段甜蜜又心动的办公室恋情就此展开。',
    status: '连载中',
    rating: 9.3,
    views: 8920000,
    chapters: 52,
    updatedAt: '2026-07-05',
    tags: ['恋爱', '职场', '甜宠'],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 3,
    slug: 'dungeon-tower',
    title: '迷宫之塔',
    author: '朴志勋',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20tower%20rising%20into%20the%20sky%20with%20a%20young%20adventurer%20standing%20at%20its%20base%2C%20fantasy%20world%20setting%20with%20magical%20glowing%20elements%2C%20deep%20blue%20and%20purple%20color%20palette%2C%20clean%20simple%20composition%2C%20adventure%20themed%20digital%20art%2C%20high%20quality%20rendering%20with%20atmospheric%20lighting&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    description: '一座突然出现在城市中心的巨大迷宫塔，据说塔顶藏着可以实现任何愿望的宝物。无数冒险者涌入其中，但没有人知道塔内究竟有什么。少年金宇镇为了拯救生病的妹妹，毅然踏入了迷宫之塔。',
    status: '连载中',
    rating: 9.5,
    views: 15600000,
    chapters: 128,
    updatedAt: '2026-07-07',
    tags: ['冒险', '奇幻', '升级'],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 4,
    slug: 'the-villainess-reverses',
    title: '恶女逆袭记',
    author: '崔秀英',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20manhwa%20style%20illustration%20of%20a%20noblewoman%20in%20an%20elaborate%20Victorian%20dress%20with%20jewelry%2C%20confident%20expression%2C%20royal%20palace%20interior%20background%20with%20warm%20candlelight%2C%20romance%20fantasy%20theme%2C%20elegant%20and%20refined%20art%20style%2C%20soft%20gold%20and%20rose%20tones%2C%20high%20quality%20digital%20illustration&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    description: '穿越到小说中成为恶毒女配的艾琳娜，为了不被主角团消灭，决定先下手为强。但她不知道的是，原著的剧情正被她一步步改写，而那个本该恨她入骨的王太子，看她的眼神却越来越不对劲了...',
    status: '连载中',
    rating: 9.4,
    views: 10800000,
    chapters: 94,
    updatedAt: '2026-07-06',
    tags: ['穿越', '逆袭', '宫廷'],
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 5,
    slug: 'blood-rose-detective',
    title: '血玫瑰侦探社',
    author: '郑宇成',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20Korean%20manhwa%20style%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20alleyway%20at%20night%2C%20mysterious%20noir%20vibe%20with%20red%20accents%2C%20crime%20thriller%20theme%2C%20dramatic%20shadows%20and%20street%20lamp%20lighting%2C%20simple%20composition%20with%20clean%20lines%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    description: '前刑警韩智浩开了一家私人侦探社，专门调查警方不愿插手的案件。某天，一位神秘女子找上门来，委托他调查五年前的一桩连环杀人案。随着调查深入，他发现这个案件与自己的过去有着千丝万缕的联系。',
    status: '已完结',
    rating: 9.2,
    views: 6300000,
    chapters: 72,
    updatedAt: '2026-05-15',
    tags: ['悬疑', '推理', '都市'],
    featured: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 6,
    slug: 'campus-star',
    title: '校园之星',
    author: '朴宝英',
    category: 'school',
    cover: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20cheerful%20Korean%20manhwa%20style%20illustration%20of%20high%20school%20students%20in%20school%20uniforms%20smiling%20under%20cherry%20blossom%20trees%2C%20youthful%20and%20energetic%20vibe%2C%20spring%20atmosphere%20with%20soft%20pink%20petals%2C%20warm%20sunlight%2C%20clean%20and%20simple%20composition%2C%20slice%20of%20life%20theme%2C%20high%20quality%20digital%20illustration&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    description: '平凡的高中生李星辰，因为一次偶然的机会被星探发现，从此踏上了偶像练习生的道路。校园生活与训练日常交织在一起，友情、梦想、懵懂的爱情——这是属于他们的青春物语。',
    status: '连载中',
    rating: 8.9,
    views: 4500000,
    chapters: 38,
    updatedAt: '2026-07-04',
    tags: ['校园', '青春', '偶像'],
    featured: false,
    isNew: true,
    isHot: false,
  },
  {
    id: 7,
    slug: 'the-chef-from-another-world',
    title: '异世界料理师',
    author: '姜东元',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20chef%20in%20apron%20holding%20a%20magical%20glowing%20dish%20in%20a%20fantasy%20medieval%20kitchen%20setting%2C%20warm%20inviting%20atmosphere%20with%20steam%20and%20magic%20sparkles%2C%20food%20and%20adventure%20theme%2C%20cozy%20vibe%20with%20rich%20colors%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    description: '天才厨师韩俊昊在参加国际料理大赛的途中遭遇车祸，醒来时发现自己穿越到了剑与魔法的异世界。在这里，他的料理竟然能赋予食用者各种神奇的能力！从此，他凭借一把菜刀在异世界掀起了一场美食革命。',
    status: '连载中',
    rating: 9.1,
    views: 7800000,
    chapters: 65,
    updatedAt: '2026-07-03',
    tags: ['穿越', '美食', '冒险'],
    featured: false,
    isNew: false,
    isHot: true,
  },
  {
    id: 8,
    slug: 'daily-life-of-a-cat',
    title: '我家猫主子的日常',
    author: '金多美',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20and%20funny%20Korean%20manhwa%20style%20illustration%20of%20a%20fluffy%20orange%20cat%20sitting%20on%20a%20couch%20with%20a%20disdainful%20expression%2C%20cozy%20apartment%20living%20room%20background%2C%20slice%20of%20life%20comedy%20theme%2C%20warm%20and%20inviting%20color%20palette%2C%20clean%20simple%20composition%2C%20playful%20and%20lighthearted%20mood%2C%20high%20quality%20digital%20illustration&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    description: '社畜林晓晓养了一只橘猫叫大王，每天下班回家都要伺候这位猫主子。从猫的视角看人类社畜的搞笑日常，有笑有泪，治愈你的心。',
    status: '连载中',
    rating: 9.0,
    views: 3200000,
    chapters: 24,
    updatedAt: '2026-07-02',
    tags: ['日常', '搞笑', '治愈'],
    featured: false,
    isNew: true,
    isHot: false,
  },
  {
    id: 9,
    slug: 'emperor-of-the-east',
    title: '东皇传',
    author: '金秀贤',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=A%20majestic%20Korean%20manhwa%20style%20illustration%20of%20an%20ancient%20emperor%20in%20elaborate%20traditional%20royal%20robes%20standing%20in%20a%20grand%20palace%20hall%2C%20historical%20dynasty%20setting%20with%20ornate%20architecture%2C%20gold%20and%20crimson%20color%20scheme%2C%20dramatic%20and%20powerful%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    description: '少年刘彻在意外中获得了预知未来的能力，他看到了东皇朝将在三年后覆灭的结局。为了改变命运，他化名潜入朝堂，一步步从无名小卒成长为一代帝王。权谋、战争、爱恨交织的史诗篇章就此展开。',
    status: '连载中',
    rating: 9.7,
    views: 18200000,
    chapters: 156,
    updatedAt: '2026-07-07',
    tags: ['历史', '权谋', '史诗'],
    featured: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 10,
    slug: 'the-hunters-daughter',
    title: '猎人之女',
    author: '刘在石',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20fierce%20Korean%20manhwa%20style%20illustration%20of%20a%20strong%20female%20warrior%20with%20a%20bow%20and%20arrow%20in%20a%20dense%20forest%20setting%2C%20action%20adventure%20theme%2C%20dynamic%20pose%20with%20flowing%20cape%2C%20green%20and%20earthy%20tones%2C%20dramatic%20lighting%20through%20trees%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    description: '在怪物横行的世界里，猎人是人类最后的防线。少女韩素希的父亲是S级猎人，但在一次SSS级任务中失踪。为了寻找父亲的下落，素希继承了父亲的遗志，踏上了成为猎人的道路。',
    status: '连载中',
    rating: 9.0,
    views: 5600000,
    chapters: 48,
    updatedAt: '2026-07-01',
    tags: ['怪物', '战斗', '成长'],
    featured: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 11,
    slug: 'moonlight-garden',
    title: '月光花园',
    author: '金智媛',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20melancholic%20Korean%20manhwa%20style%20illustration%20of%20a%20woman%20in%20a%20white%20dress%20standing%20in%20a%20moonlit%20garden%20filled%20with%20glowing%20flowers%2C%20poetic%20and%20dreamy%20atmosphere%2C%20soft%20silver%20and%20blue%20moonlight%2C%20romantic%20drama%20theme%2C%20clean%20simple%20composition%2C%20high%20quality%20art%20with%20ethereal%20lighting&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    description: '尹书妍失去了五岁之前的全部记忆。某天她回到老家，在月光下的后花园里，记忆的碎片开始浮现。那是一座只在月光下才会盛开的花园，而花园里埋藏着一个关于爱与失去的悲伤故事。',
    status: '已完结',
    rating: 9.3,
    views: 4100000,
    chapters: 42,
    updatedAt: '2026-04-20',
    tags: ['治愈', '悬疑', '情感'],
    featured: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 12,
    slug: 'rebirth-of-the-sword-god',
    title: '剑神重生',
    author: '金贤重',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20epic%20Korean%20manhwa%20style%20illustration%20of%20a%20swordsman%20in%20flowing%20martial%20arts%20robes%20performing%20a%20powerful%20sword%20technique%20with%20energy%20waves%2C%20martial%20arts%20cultivation%20theme%2C%20dramatic%20golden%20and%20crimson%20energy%20effects%2C%20ancient%20Chinese%20style%20mountain%20background%2C%20clean%20composition%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    description: '一代剑神林玄在渡劫失败后重生回到少年时代。带着前世的武道记忆与修炼经验，他誓要弥补所有遗憾，重登剑道巅峰，守护身边所有珍视之人。',
    status: '连载中',
    rating: 9.5,
    views: 14200000,
    chapters: 112,
    updatedAt: '2026-07-06',
    tags: ['重生', '修仙', '热血'],
    featured: true,
    isNew: false,
    isHot: true,
  },
];

export const siteInfo = {
  name: '爱漫画',
  slogan: '韩国漫画无删减漫画下拉式-免费韩漫大全',
  description: '爱漫画是国内领先的韩国漫画在线阅读平台，致力于为广大韩漫爱好者提供无删减、高品质的韩漫阅读体验。我们拥有海量韩漫资源，涵盖恋爱、奇幻、热血、悬疑、搞笑等多种类型，支持下拉式阅读模式，让您随时随地畅享韩漫的精彩世界。',
  founded: '2020年',
  address: '北京市朝阳区望京SOHO T3 18层',
  email: 'contact@aimanga.com',
  phone: '400-888-6666',
  wechat: 'aimanga_official',
  weibo: '@爱漫画官方',
};

export const testimonials = [
  {
    name: '王晓明',
    role: '资深韩漫读者',
    content: '爱漫画是我用过最好的韩漫阅读平台，资源全、更新快、画质高。尤其是下拉式阅读体验，太流畅了！已经推荐给身边所有喜欢韩漫的朋友了。',
    rating: 5,
  },
  {
    name: '李思雨',
    role: '漫画博主',
    content: '作为一个漫画博主，我每天都要看大量的漫画。爱漫画的韩漫资源是最全的，而且无删减版本对创作者来说非常重要。网站的阅读体验也是一流的。',
    rating: 5,
  },
  {
    name: '张浩然',
    role: '韩漫爱好者',
    content: '入坑韩漫两年，从其他平台转到爱漫画后就没换过。界面简洁好看，分类清晰，各种类型的韩漫都有，更新速度也很快，五星好评！',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '爱漫画上的韩漫都是免费的吗？',
    answer: '是的，爱漫画平台上的所有韩国漫画均提供免费在线阅读服务。我们致力于为广大韩漫爱好者打造一个优质、免费、无删减的阅读平台，让每一位读者都能畅享韩漫的魅力。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读模式是一种专为移动端和网页端优化的阅读方式，读者只需上下滑动页面即可连续阅读漫画内容，无需频繁翻页。这种模式更加流畅自然，适合在手机、平板等设备上阅读长篇韩漫。',
  },
  {
    question: '爱漫画的漫画更新频率如何？',
    answer: '我们的编辑团队每日跟踪最新韩漫更新动态，热门连载漫画通常能在原作更新后24小时内同步上线。平台每日上新多部韩漫作品，确保读者能够第一时间阅读到最新内容。',
  },
  {
    question: '爱漫画支持哪些设备阅读？',
    answer: '爱漫画完美适配PC端、平板端和手机端，您可以在电脑浏览器、平板浏览器以及手机浏览器上流畅阅读。下拉式阅读模式在所有设备上都能提供出色的阅读体验。',
  },
  {
    question: '如何联系爱漫画客服？',
    answer: '您可以通过以下方式联系我们：发送邮件至 contact@aimanga.com，或关注微信公众号 aimanga_official 留言。我们的客服团队会在24小时内回复您的咨询。',
  },
];